var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOnlinePaymentIcon = function SvgOnlinePaymentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0739 2.62131C11.3444 2.42931 11.6679 2.32617 11.9997 2.32617C12.3314 2.32617 12.655 2.42931 12.9255 2.62131L19.9479 7.60371C20.8203 8.22291 20.3835 9.59811 19.3143 9.60051H4.68868C3.61588 9.60051 3.17668 8.22411 4.05268 7.60371L11.0739 2.62131ZM12.0003 7.05051C12.2655 7.05051 12.52 6.94514 12.7075 6.75756C12.8951 6.56999 13.0005 6.31558 13.0005 6.05031C13.0005 5.78504 12.8951 5.53064 12.7075 5.34306C12.52 5.15549 12.2655 5.05011 12.0003 5.05011C11.735 5.05011 11.4806 5.15549 11.293 5.34306C11.1055 5.53064 11.0001 5.78504 11.0001 6.05031C11.0001 6.31558 11.1055 6.56999 11.293 6.75756C11.4806 6.94514 11.735 7.05051 12.0003 7.05051Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40039 10.8008V15.6008H7.80039V10.8008H5.40039Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60059 19.4012C3.60059 17.9648 4.76459 16.8008 6.19979 16.8008H17.8002C19.2366 16.8008 20.4006 17.9648 20.4006 19.4012V19.8008C20.4006 19.9599 20.3374 20.1125 20.2249 20.225C20.1123 20.3376 19.9597 20.4008 19.8006 20.4008H4.20059C4.04146 20.4008 3.88884 20.3376 3.77632 20.225C3.6638 20.1125 3.60059 19.9599 3.60059 19.8008V19.4012Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6002 10.8008V15.6008H16.2002V10.8008H18.6002Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0006 10.8008V15.6008H12.6006V10.8008H15.0006Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 10.8008V15.6008H9V10.8008H11.4Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnlinePaymentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/online_payment_icon.ef26ed4a.svg";
export { ForwardRef as ReactComponent };